import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pv-product-list-group',
  templateUrl: './product-list-group.component.html',
  styleUrls: ['./product-list-group.component.scss']
})
export class ProductListGroupComponent implements OnInit {
  @Input() group;
  @Input() homepage: boolean;
  @Input() noShowMore: boolean;
  toShow = 12;

  constructor() { }

  ngOnInit() {
    this.toShow = this.group.items_per_page || 12;
  }

}
